import analytics from 'product-analytics'
import { useEffect } from 'react'
import { TrackingCookieType } from './types'

function useAnalytics(status: TrackingCookieType | undefined) {
  useEffect(() => {
    switch (status) {
      case undefined:
        return analytics.optInOutNotSet()
      case 'accepted':
        return analytics.optIn()
      case 'rejected':
        return analytics.optOut()
      default:
        analytics.optInOutPending()
    }
  }, [status])

  useEffect(() => {
    return () => {
      analytics.cancel()
    }
  }, [])
}

export default useAnalytics
